module.exports = __webpack_public_path__ + "static/media/4.c33b7d5a.JPG";